import { createSelector } from '@reduxjs/toolkit';

import { State } from './types';
import { RootState } from '../root-reducer';

const rootSelector = (state: RootState): State => state.UsersList;

export const filtersSelector = createSelector(rootSelector, (state) => state.filters);

export const statusSelector = createSelector(rootSelector, (users) => users.status);

export const errorSelector = createSelector(rootSelector, (users) => users.error);

const usersSelector = createSelector(rootSelector, (users) => users.data);

export default {
  statusSelector,
  errorSelector,
  usersSelector,
  filtersSelector,
};
